"use strict";
define("application/modules/404/404", function(){});

